export default {
  privacypolicy: {
    'a': '本协议由盖德科技股份有限公司（以下简称为“盖德”）与您（以下简称为“用户”）订立，保证您对本应用各项服务的使用权利及隐私，请您认真阅读，一经注册或以其他方式使用我们的产品和服务，您将被视为确认接受本条款并同意成为具有约束力的本合同的一方，若您不同意任意条款请停止使用本应用。盖德可能就本应用提供的某项特定服务于您签订单独的服务条款，您在遵守本协议的同时还需要遵守与特定服务相关的特定服务条款。就相关事宜，双方达成如下协议：',
    'b': '使用前提',
    'c': '1. 用户必须同意本协议条款后才能使用。',
    'd': '2. 若您在18周岁以下，您必须确保在父母或监护人的监护下使用。',
    'e': ' 若您在18周岁以下，您必须确保在父母或监护人的监护下使用。 ',
    'f': '3. 您同意盖德在法律允许范围内有权独自决定关闭您的账户、清除账户内资讯。 ',
    'g': '4. 您必须能够自行通过有法律资格的第三方对您提供互联网接入服务，并自行承担以下内容：',
    'h': '1) 自行配备上网设备，包括个人计算机，调制解调器及其他必要的设备装置；',
    'i': '2) 自行承担上网费用，如网络接入费用、电话费用、流量费用等',
    'j': '责任限制及不承诺担保',
    'k': '1. 您同意在自己承担风险的情况下，按本应用的现状使用相关产品及服务。盖德特此申明对本应用之使用不提供任何保证（包含但不限于商业担保和特殊目的的适用性担保），亦不对您因服务暂停或终止而遭受的任何直接或间接损失承担责任。盖德不保证您一定能够获得服务，盖德有权随时暂停或终止全部或部分服务。 ',
    'l': '2. 本应用所有信息都不能作为诊断、用药及医疗的依据。您同意就基于经阅读本应用发布的信息做出的任何行为及后果（包括盖德可能遭受的任何损失或损害）承担责任，盖德不对您或任何第三方承担责任。 ',
    'm': '3. 本应用中向您提供的任何反馈、意见或建议仅是依据您描述提供的建议性内容，不能作为诊断、用药及医疗的依据，是否采用是您的个人行为，盖德不承担其言行导致后果承担任何责任',
    'n': '4. 您理解本应用中可能包含由第三方提供的服务，盖德只是为了您的便利而提供功能模块。您使用第三方提供的服务，需与第三方另行达成服务协议，支付相应的费用并承担可能的风险。盖德对第三方所提供的服务不承担任何形式的担保。',
    'o': '非排他性许可',
    'p': '1. 本应用（包括但不限于本应用中所含的任何图像、照片、动画、文字和附加程序、修正程序、更新版本和升级版本）的一切所有权和知识产权，均由盖德拥有。',
    'q': '2. 盖德仅可撤销、非排他地授权您，依照本协议条款和条件，(a)为在您的网站或第三方网站上使用本应用服务的需要而安装、复制和使用本应用； (b) 在遵守所有的适用法律和法规的前提下，通过远程访问、浏览和下载您的本应用的数据。',
    'r': '隐私权保护',
    's': '1. 盖德尊重并保护您的隐私权，您注册的账户名、电子邮件地址、证件信息、您提交的健康信息等个人信息，非经您的许可，或根据相关法律、法规的强制性规定或您的允许，以及盖德为维护改进软件服务为目的等，不会主动地泄露给第三方。',
    't': '本应用还可能收集您的IP地址、移动设备类型、浏览器性质、操作系统类型等非个人信息以便优化您在本应用的用户体验',
    'u': '您在使用该软件的过程中应当遵守法律法规中关于隐私权的保护，不得自行（且不得允许任何第三方）使用本应用追踪或收集互联网用户的个人身份信息，也不得自行（且不得允许任何第三方）将从您的网站（或该第三方的网站）收集的任何数据与从任何来源获得的任何个人身份信息相联系。',
    'v': '4. 信息披露 在如下情况下，本应用将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：',
    'w': '1)经您事先同意，向第三方披露；',
    'x': '2)为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；',
    'y': '3)根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；',
    'z': '4)如您出现违反有关法律、法规或者本应用服务协议或相关规则的情况，需要向第三方披露；',
    'aa': '5) 如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；',
    'bb': '6) 其他本应用根据法律、法规或者网站政策认为合适的披露。',
    'cc': '终止',
    'dd': '1. 若您违反本协议的任何条款，盖德有权立即终止本协议。同时盖德有权在没有任何理由和/或通知的情形下随时终止或暂停对您的授权。授权一旦取消，您使用本应用的权利即刻终止。此种情况下您必须停止使用本应用，销毁本应用及其各部分的所有副本，并在终止后三个工作日内以书面形式向盖德做出销毁证明，否则，用户将承担相应的未经授权使用他人软件的法律责任。',
    'ee': '2. 若因您违反本协议导致协议终止：',
    'ff': '1)您无权得到任何损失补偿；',
    'gg': '2)您将无权获得您的一切历史数据。',
    'hh': '不可抗力',
    'ii': '除法律规定不可抗力情形外，下列情况亦属于不可抗力： ',
    'jj': '1. 任何公共的互联网骨干网、网络或服务器停运。',
    'kk': '2. 您的设备、系统或当地连接服务发生故障。',
    'll': '3. 已经预定的维修。',
    'mm': '4. 您的服务器所在地区的互联网服务中断。',
    'nn': '5. 黑客攻击。',
    'oo': '6. 公司业务调整或其他不能预见的情况。',
    'pp': '条款和政策的修改及关注义务',
    'qq': '本应用新推出的产品、服务，新增加的功能均受到本协议的规范。盖德有权修改、变更本协议条款和服务政策，您有责任定期查看。如您不接受变更、修改后的协议条款和服务政策的，应立即停止使用本软件，并按照终止条款的规定销毁已下载使用的软件产品。若您接受变更后的条款或继续使用本应用的服务，表明您接受变更后的协议约束。',
    'rr': '法律适用及管辖',
    'ss': '本协议的订立、执行和解释均适用中华民国地区适用之法律。因本协议或使用本软件产品所引起的争议由当地人民法院或其上级法院管辖。盖德对本协议内容拥有合法范围内最终解释权',
    'tt': '感谢您使用本应用，我们将致力于为您提供更贴心的服务！'
  }
}
